import { createFileRoute } from "@tanstack/react-router";

import { NewsletterArchive } from "@/features/newsletter/modules/newsletter-archive/newsletter-archive";
import { m } from "@/paraglide/messages.js";

export const Route = createFileRoute("/(public)/newsletter/")({
  component: RouteComponent,
  loader: () => ({ crumb: m.newsletter_archive_crumb() }),
});

function RouteComponent() {
  return <NewsletterArchive />;
}
